import styled from 'styled-components'
import { ImageOptions, getImageUrl } from '@/utils/image'
import { Avatar as BaseAvatar, defaultAvatar } from '@/components/avatar'

const AvatarWrapper = styled.div<{ $border?: boolean }>`
  ${props =>
    props.$border &&
    `
    flex: 50px 0 0;
    > div {
      border: 3px solid rgb(255 255 255 / 40%);
      background: none;
    }
  `};
`

const getImage = (url?: string, options?: ImageOptions) =>
  url ? getImageUrl(url, options) : defaultAvatar

type AvatarProps = {
  avatarUrl?: string
  width?: number
  height?: number
  border?: boolean
}

export const Avatar: React.FC<AvatarProps> = ({ avatarUrl, width = 36, height = 36, border }) => (
  <AvatarWrapper $border={border}>
    <BaseAvatar
      location={getImage(avatarUrl, { width: Math.max(width, 60), height: Math.max(height, 60) })}
      width={width}
      height={height}
    />
  </AvatarWrapper>
)

const TEXT_COLORS: Record<string, string> = {
  excellent: '#FFC42C',
  'very good': '#FFF',
  average: '#FFF',
  poor: '#C10C00',
  pending: '#000',
  analyzing: '#000',
  request: '#FFC42C'
}

// Marks any unknown Trust Score
// as pending color badge.
export const getColor = (value: string): string =>
  !value || ['N/A', 'not enough'].indexOf(value) > -1 ? 'pending' : value

export const getCardColor = (value: string): string => `card-${getColor(value)}`

export const getTextColor = (value: string): string => TEXT_COLORS[getColor(value)]

export type User = {
  first_name?: string
  preferred_name?: string
  last_name?: string
}

export const formatName = (user: User): string =>
  `${user?.preferred_name || user?.first_name}${user?.last_name ? ' ' + user?.last_name : ''}`
